import globalStore from "@/store/index";

const account = {
  namespaced: true,
  state: {},
  actions: {
    CHANGE_PASSWORD: function({ state }, model) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/users/change-password", model)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
  },
  mutations: {},
};
export default account;
